// SessionContext.js
import { createContext, useState, useEffect } from 'react';
import { sendSessionDataToServer } from '../api/sessionsApi';

const SessionContext = createContext();


/**
 * Provides session start time context and manages the sending of session end data to the server
 * when the user is about to leave the page. Utilizes navigator.sendBeacon for reliable data
 * sending on page unload.
 *
 * @param {object} props - The properties passed to the SessionProvider component.
 * @returns {JSX.Element} - A provider component that wraps children with session context.
 */
const SessionProvider = ({ children }) => {
  const [sessionStartTime, setSessionStartTime] = useState(null);

  useEffect(() => {
    const startTime = new Date().getTime() / 1000;
    setSessionStartTime(startTime);

    const handleBeforeUnload = () => {
      const endTime = new Date().getTime() / 1000;
      const sessionData = {
        startTime,
        endTime,
        userId: localStorage.getItem('uid')
        // Add any other relevant session data
      };
      // Send session data to the server using an API call
      sendSessionDataToServer(sessionData);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [sessionStartTime]);

  return (
    <SessionContext.Provider value={{ sessionStartTime }}>
      {children}
    </SessionContext.Provider>
  );
};

export default SessionProvider;